module.exports = __webpack_public_path__ + "img/logo_on-white.7c9259d8.svg";